"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FlagFilled = function FlagFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.992 3.414l3 17a.5.5 0 01-.405.579A.521.521 0 017.5 21a.5.5 0 01-.492-.414l-3-17a.5.5 0 11.984-.173zm1.659 9.346L5.2 4.548l1.451 8.212zM19 4.438a.5.5 0 00-.786-.345A6.05 6.05 0 0115 5a4.923 4.923 0 01-2.59-.895A6.423 6.423 0 009 3a7.183 7.183 0 00-2.928.724l1.617 9.163c.061-.046.116-.092.181-.137A3.771 3.771 0 0110 12a4.993 4.993 0 012.782.938A5.762 5.762 0 0016 14a6.275 6.275 0 003.817-1.113.5.5 0 00.183-.449z",
    fill: "currentColor"
  })));
};

var _default = FlagFilled;
exports["default"] = _default;